let existingSetQuestions: any = [];
export const setCheckBoxData = (data: any) => data ? existingSetQuestions.push(data) : existingSetQuestions = [];
export const getCheckBoxData = () => existingSetQuestions;

export const assessmentDetails: any = [];
export const ansObj: any = [];

let selectedQuesData: any;
export const setSelectedQuesData = (data: any) => selectedQuesData = data ? data : null;
export const getSelectedQuesData = () => selectedQuesData;

let newSetQuestions: any = [];
export const setNewQuesData = (data: any) => newSetQuestions = data && data.length ? data : [];
export const getNewQuesData = () => newSetQuestions;

let newSetAnswers: any = [];
export const setNewAnsData = (data: any) =>  newSetAnswers = data && data.length ? data : [];
export const getNewAnsData = () => newSetAnswers;